import React, { useEffect, useState } from "react";
import GolfScoreInfo from "./GolfScoreInfo";
import GolfRounds from "./GolfRounds";
import { loadStyles } from "../../utils/cssLoader";

const PlayersDetail = ({
  data,
  dataClient,
  loadCSS
}) => {
  const [clientData, setClientData] = useState([]);

  useEffect(() => {
    if (!dataClient) return;
    const container = document.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || []);
    } catch (error) {
      console.error("Failed to parse client data:", error);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("golf");
    }
  }, [loadCSS]);


  const finalData = dataClient ? clientData : data;
  return (
    <div className="golf_players_detail">
      <GolfRounds data={finalData} />
      <GolfScoreInfo />
    </div>
  );
};

export default PlayersDetail;
